import { Star } from "lucide-react";

interface StarRatingProps {
  rating: number;
  size?: number;
  className?: string;
}

/** 5-star display; supports half-star fill via clip width. */
export function StarRating({ rating, size = 14, className = "" }: StarRatingProps) {
  const pct = Math.max(0, Math.min(5, rating)) / 5 * 100;
  return (
    <span
      className={`relative inline-flex ${className}`}
      role="img"
      aria-label={`${rating} out of 5 stars`}
      style={{ width: size * 5 + 4 }}
    >
      <span className="flex gap-[1px] text-[#D4CCBC]">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} className="fill-current" strokeWidth={0} />
        ))}
      </span>
      <span
        className="absolute inset-0 flex gap-[1px] overflow-hidden text-[#FA5021]"
        style={{ width: `${pct}%` }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} className="fill-current flex-shrink-0" strokeWidth={0} />
        ))}
      </span>
    </span>
  );
}
